module.exports = __webpack_public_path__ + "static/ScrollVideoDesktop-f5eb687a282ad1010d275c0fe7c16c48.mp4";